import { jwtDecode } from "jwt-decode"; // ✅ Named import with correct name

export function isTokenValid(token) {
  if (!token) return false;
  try {
    const decoded = jwtDecode(token); // ✅ Matches imported function
    const currentTime = Date.now() / 1000;
    return decoded.exp && decoded.exp > currentTime;
  } catch (err) {
    return false;
  }
}
